/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2023-11-07 15:33:56
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_change\src\api\smart\specialmaterial\Deplan.js
 */
/*
 * @Description: 
 * @Autor: wangwangwang
 * @Date: 2021-01-12 12:08:10
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-04-27 11:53:25
 */
import request from '@/utils/request'
export const queryPage = '/icps/system/sign/intelligent/materials/plan/need/queryPage'
//接单或修改
export function needupdateData(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/plan/need/updateData',
    method: 'post',
    data
  })
}
//车辆管理分页查询
export function carqueryPage(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/car/queryPage',
    method: 'post',
    data
  })
}
//特材运输清单分页查询
export function shippingqueryPage(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/shipping/queryPage',
    method: 'post',
    data
  })
}
//特材运输清单分页查询
export function queryShippingPage(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/plan/need/queryShippingPage',
    method: 'post',
    data
  })
}
//需求计划根据需求id车牌获取合同列表
export function queryCarContractList(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/plan/need/queryCarContractList',
    method: 'post',
    data
  })
}
//外加剂返料根据需求id车牌获取合同列表
export function queryCarContractList2(data) {
  return request({
    url: '/icps/system/sign/intelligent/warehouse/return/queryCarContractList',
    method: 'post',
    data
  })
}
